export default "__VITE_ASSET__yQkDuD_G__"